import { WebsiteIcon } from 'foundations-assets/icons/components/WebsiteIcon';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { H4 } from 'foundations-components/transitional/components/H4';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { UsageScreenProvider, useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback } from 'react';
import { EcosystemSlider } from 'trellis-ecosystem';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { useAppContext } from '../../context/AppContext';
import { isProd } from '../../utils/env';
import { getSolutionsDirectoryUrl } from '../../utils/urls';
import { CAROUSEL_SERVICES_PROD, CAROUSEL_SERVICES_QA } from '../constants/index';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BrowsePopularPartnersSliderSection() {
  const appContext = useAppContext();
  const lang = getLang();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const cards = isProd() ? CAROUSEL_SERVICES_PROD : CAROUSEL_SERVICES_QA;
  const trackSliderButtonClicked = useCallback(direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggestion section ${direction} arrow clicked`,
      itemIndex: 0,
      subscreen: Subscreens.SUGGESTION_SECTION
      // To do: add section, type, and value
    }));
  }, [trackMarketplaceEvent]);
  const onLinkClick = index => {
    trackMarketplaceEvent(getSearchResultClickedEvent({
      resultCount: cards.length,
      resultIndex: index,
      resultType: 'SOLUTIONS_PARTNERS'
    }));
  };
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.SUGGESTION_SECTION,
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": "slider-section",
      marginBlockEnd: "1000",
      maxInlineSize: "100%",
      children: /*#__PURE__*/_jsx(EcosystemSlider, {
        cardWidth: 306,
        gradientColor: "fill-surface-recessed",
        onScrollButtonClick: trackSliderButtonClicked
        // I've eyeballed this so the center of the scroll buttons aligns with the bottom of the card image background
        ,
        scrollButtonTop: "32.5%",
        title: unescapedText('marketplaceStorefront.sliderSection.browsePartners'),
        topRightSlot: /*#__PURE__*/_jsx(UIRouterLink, {
          to: Paths.SOLUTIONS_PARTNERS_ALL,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.sliderSection.seeMore"
          })
        }),
        children: cards.map((card, index) => {
          var _card$icon, _card$color, _card$color2;
          return /*#__PURE__*/_jsx(CardWrapper, {
            margin: "0",
            minInlineSize: "306px",
            inlineSize: "306px",
            children: /*#__PURE__*/_jsx(Link, {
              color: "text-core-default",
              href: `${getSolutionsDirectoryUrl(appContext, lang)}${card.slug}`,
              onClick: () => onLinkClick(index),
              textDecoration: "none",
              children: /*#__PURE__*/_jsxs(CardSection, {
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBlock: "300",
                minBlockSize: "104px",
                children: [/*#__PURE__*/_jsx(H4, {
                  margin: "0",
                  children: card.partnerService
                }), /*#__PURE__*/_jsx(IconCircle, {
                  icon: (_card$icon = card.icon) !== null && _card$icon !== void 0 ? _card$icon : WebsiteIcon,
                  color: "icon-core-default",
                  backgroundColor: (_card$color = card.color) !== null && _card$color !== void 0 ? _card$color : 'fill-accent-blue-subtle-alt',
                  borderColor: (_card$color2 = card.color) !== null && _card$color2 !== void 0 ? _card$color2 : 'fill-accent-blue-subtle-alt',
                  size: "400"
                })]
              })
            })
          }, index);
        })
      })
    })
  });
}